import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import it from "./it.json";
import en from "./en.json";
import de from "./de.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: "it",
    supportedLngs: ["it", "en", "de"],
    interpolation: { escapeValue: false },
    detection: {
      // Only respect an explicit choice stored in localStorage; the admin
      // `default_language` (fetched by SettingsContext) becomes the fallback
      // when no user pick is present.
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "lp_lang",
    },
  });

/** Merge translations coming from the admin DB into the current i18n resources. */
export function mergeRemoteTranslations(remote) {
  if (!remote) return;
  ["it", "en", "de"].forEach((lng) => {
    if (remote[lng]) i18n.addResourceBundle(lng, "translation", remote[lng], true, true);
  });
}

export default i18n;
